import React from 'react';
import { useTransition } from 'react-spring';

import Toast from './Toast';

import { ToastMessage } from '../../hooks/toast';
import { Container } from './styles';

interface ToastContainerProps {
  messages: ToastMessage[];
}

const ToastContainer: React.FC<ToastContainerProps> = ({ messages }) => {
  const messagesWithTransitions = useTransition(
    messages,
    // (message: ToastMessage) => message.id,
    {
      from: { right: '-120%', opacity: 0 },
      enter: { right: '0%', opacity: 1 },
      leave: { right: '-120%', opacity: 0 },
      keys: (message: ToastMessage) => message.id
    });

  return (
    <Container>
      {/* messagesWithTransitions.map(({ item, key, props }: any) => ( */}
      {messagesWithTransitions((style, item, _, key) => (
        <Toast key={key} style={style} message={item} />
      ))}
    </Container>
  );
};

export default ToastContainer;
